import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_ESENCIAL } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-149" data-mp="3ueq3dlo8xzve">
      {visible ? <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-ink/95 px-5 py-3 backdrop-blur md:px-8" data-id="element-150" data-mp="3gm0cb2tv24rf">
          <div className="mx-auto flex max-w-content items-center justify-between gap-4" data-id="element-151" data-mp="gz0gx21nqmw5">
            <div className="min-w-0" data-id="element-152" data-mp="76f6wl0ksxjk">
              <p className="truncate text-sm font-bold text-white" data-id="element-153" data-mp="26sz4r3io9i5">
                Mega Pack Esencial — <span className="text-white/50 line-through" data-id="element-154" data-mp="24yd19giebch">$60.000</span>{' '}
                $19.990 ARS
              </p>
              <p className="hidden text-xs font-medium text-white/50 sm:block" data-id="element-155" data-mp="c4gqd71wyyvk">
                3 Tomos + 6 Bonos · Garantía 7 días · Acceso en 5 min
              </p>
            </div>
            <a href={CHECKOUT_ESENCIAL} onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'Mega Pack Esencial',
          value: 19990,
          currency: 'ARS'
        })} className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-accent px-5 py-3 text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-accent-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-156" data-mp="lv1zvpj4lnt9">
              Comprar ahora
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-157" data-mp="15jbb45iyc6qj" />
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}